'use client';

import Heading from 'src/components/Heading/Heading';
import styles from './accordion.module.scss';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import HairAccordionColumns from 'src/views/Hair/HairAccordionColumns';
import { Content } from '@prismicio/client';

type AccordionProps = SliceComponentProps<Content.AccordionSlice>;

const Accordion = ({ slice }: AccordionProps) => {
    const items = slice.items.map((item) => {
        return {
            title: item.title ?? '',
            contentTypeNode: true,
            content: <PrismicRichText field={item.content} />,
            icon: item.icon.url
                ? {
                      src: item.icon.url,
                      alt: item.icon.alt || item.title || 'icon',
                      width: 50,
                      height: 40,
                  }
                : undefined,
        };
    });

    return (
        <section
            style={{ backgroundColor: slice.primary.background || 'bg-white' }}
        >
            <div className={styles['accordion__container']}>
                <Heading tag="h" level="h2">
                    {slice.primary.title}
                </Heading>
                <div className={styles['accordion']}>
                    <HairAccordionColumns
                        columns={items}
                        className={styles['accordion__item']}
                    />
                </div>
            </div>
        </section>
    );
};

export default Accordion;
